import {
    GovFormControl,
    GovFormGroup,
    GovFormLabel,
    GovFormMessage,
    GovFormSelect
} from "@gov-design-system-ce/react";

export interface SingleSelectOption {
    value: string;
    label?: string;
    disabled?: boolean;
}

export interface SingleSelectProps {
    value?: string;
    readOnly?: boolean;
    label?: string;
    message?: string;
    options: SingleSelectOption[];
    onChange?: (value: string) => void;
}

export default function SingleSelect(props: SingleSelectProps) {
    const { readOnly, message, label, onChange, options, value } = props;

    return (
        <GovFormControl>
            <div>
                {label && (
                    <GovFormLabel slot="top" size="l">
                        {label}
                    </GovFormLabel>
                )}
                <GovFormGroup>
                    <GovFormSelect
                        size="m"
                        variant="secondary"
                        input-type="text"
                        disabled={readOnly}
                        onGov-change={(e) => {
                            if (onChange) {
                                onChange(e.detail.value);
                            }
                        }}
                        value={value ?? ""}
                    >
                        {options.map((option, index) => (
                            <option
                                key={index}
                                value={option.value}
                                disabled={option.disabled}
                            >
                                {option.label ?? option.value}
                            </option>
                        ))}
                    </GovFormSelect>
                </GovFormGroup>

                {message && (
                    <GovFormMessage slot="bottom" variant="secondary">
                        {message}
                    </GovFormMessage>
                )}
            </div>
        </GovFormControl>
    );
}
